import templateUrl from './termination-modal.component.html'
import { InfoModal } from '../info-modal/info-modal.component';

export const TerminationModalComponent = {
    templateUrl,
    controller: TerminationModalController,
    controllerAs: "vm",
    bindings: {
        resolve: '<',
        close: "&",
        dismiss: "&"
    }
}



function TerminationModalController($q, $uibModal, $state, $scope, utilityService, employeeService, permissionGrantService, localeService, onboardingDocumentService) {
    'ngInject'
    const vm = this;
    vm.onSubmit = onSubmit;
    vm.onClose = onClose;
    vm.validateTerminationDate = validateTerminationDate;
    vm.isReadOnly = false;
    vm.datePickerOptions = {
        change: function () {
            vm.editForm.TerminationDate.$setTouched();
        }
    };
    vm.employeeProfile;

    vm.$onInit = function () {
        console.log(vm.resolve);
        vm.employeeProfile = vm.resolve.employeeProfile;
        vm.employmentRecord = vm.resolve.employeeProfile.IcdOffices[0];
        vm.TerminationDate = vm.employmentRecord.TerminationDate;
        vm.employmentRecord.EmployeeStatus = vm.resolve.employmentStatuses.filter(function (status) {
            return Number(status.EmployeeStatusID) === Number(vm.employmentRecord.EmployeeStatusID);
        })[0];
        vm.employmentRecord.EmployeeStatus.AllowPortalAccess = vm.resolve.employeeProfile.AllowPortalAccess;
        utilityService.hideLoading();
    }

    function validateTerminationDate() {
        if (vm.TerminationDate == null) {
            vm.editForm.TerminationDate.$setValidity('required', false);
        }
        var validDate = new Date(vm.TerminationDate);
        if (!validDate) {
            vm.editForm.TerminationDate.$setValidity('required', false);
        } else {
            vm.editForm.TerminationDate.$setValidity('required', true);
        }
    }

    function onSubmit() {
        if (vm.editForm && vm.editForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return false;
        }
        vm.employmentRecord.EmployeeStatusID = 2; //terminated
        vm.employeeProfile.IcdOffices[0] = vm.employmentRecord;

        //let updatePromises = employeeService.updateOnboardingEmployee(vm.employeeProfile.Id, vm.employeeProfile);
        const trans = employeeService.updateOnboardingEmployee(vm.employeeProfile.Id, vm.employeeProfile).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        ).then(() => {
            // ? ONLY close after success
            vm.close({ $value: 'ok' });
            return 'ok';
        });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.editForm.$dirty && !vm.isSaved) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Loading Comment Failed: " + utilityService.getExceptionMessage(err));
            });
        }
    }

}


export const OnboardingTerminationModal = {
    component: "apexOnboardingTerminationModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
};
